// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__SJle8","dot":"Spinner_dot__R9Vqc","pulse":"Spinner_pulse__vLs1s"};